import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DirectiveModule } from 'src/app/directives/directive.module';
import { ErrorBusyImportComponent, ErrorDialogComponent, ReportListComponent } from './report-list.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ReportProgressModule } from '../report-progress/report-progress.module';

@NgModule({
  declarations: [ReportListComponent, ErrorDialogComponent, ErrorBusyImportComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    DirectiveModule,
    MatCardModule,
    MatIconModule,
    ReportProgressModule,
    MatProgressSpinnerModule
  ],

  exports: [ReportListComponent]
})
export class ReportListModule {}
